import { Field } from 'react-final-form'
import { type Nationality } from '../../../../model/patient'
import CountrySelect from './CountrySelect'

interface Props {
  name: string
  label: string
}

export default function CountrySelectField({ name, label }: Props) {
  return (
    <Field<Nationality>
      name={name}
      render={({ input }) => (
        <CountrySelect
          label={label}
          value={input.value}
          onChange={input.onChange}
          onBlur={input.onBlur}
        />
      )}
    />
  )
}
